import PropTypes from 'prop-types';
import { useEffect } from 'react';
import debounce from '~/helpers/debounce';

const BottomScrollListener = ({ onBottomReached, wait, children }) => {
  useEffect(() => {
    let cancelFlag = false;
    const debouncedScroll = debounce(() => {
      if (!cancelFlag && window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
        onBottomReached();
      }
    }, wait);

    window.addEventListener('scroll', debouncedScroll, false);
    return () => {
      cancelFlag = true;
      window.removeEventListener('scroll', debouncedScroll, false);
    };
  }, [onBottomReached, wait]);

  return children;
};

BottomScrollListener.propTypes = {
  onBottomReached: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  wait: PropTypes.number,
};

BottomScrollListener.defaultProps = {
  wait: 1000,
};

export default BottomScrollListener;
